import { ErrorBoundary } from "@payping/web-components";
import { FallbackRender } from "@sentry/react";
import * as Sentry from "@sentry/react";
import { FC, PropsWithChildren, useEffect } from "react";
import { useAppTranslation } from "./utils/useAppTranslation";
import { removeLoading } from "./utils";

// If Error happens on the first page of the app, it should remove the loading so the error is seen
const CustomErrorBoundary: FallbackRender = (props) => {
  useEffect(() => {
    removeLoading();
  }, []);

  return <ErrorBoundary onRefreshAppClick={props.resetError} />;
};

export const AppErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useAppTranslation();

  return (
    <Sentry.ErrorBoundary
      fallback={(p) => <CustomErrorBoundary {...p} />}
      showDialog
      dialogOptions={{
        errorFormEntry: t("errorBoundary.feedBack.errorFormEntry"),
        errorGeneric: t("errorBoundary.feedBack.errorGeneric"),
        labelClose: t("errorBoundary.feedBack.labelClose"),
        labelComments: t("errorBoundary.feedBack.labelComments"),
        labelEmail: t("errorBoundary.feedBack.labelEmail"),
        labelName: t("errorBoundary.feedBack.labelName"),
        labelSubmit: t("errorBoundary.feedBack.labelSubmit"),
        lang: "en",
        subtitle: t("errorBoundary.feedBack.subtitle"),
        subtitle2: t("errorBoundary.feedBack.subtitle2"),
        successMessage: t("errorBoundary.feedBack.successMessage"),
        title: t("errorBoundary.feedBack.title"),
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
